import type { SolverProgressV2 } from '@minglun/protocol';

export function createProgressStore() {
  let current: SolverProgressV2 | undefined;
  let pending: SolverProgressV2 | undefined;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const listeners = new Set<() => void>();
  const flush = () => { clearTimeout(timer); timer=undefined; current=pending; listeners.forEach(listener=>listener()); };
  return {
    getSnapshot: () => current,
    subscribe: (listener:()=>void) => { listeners.add(listener); return()=>{listeners.delete(listener);}; },
    set(value:SolverProgressV2|undefined, immediate=false) {
      pending=value;
      if(immediate || !value || !current || value.status !== current.status || value.stage !== current.stage) flush();
      else if(!timer) timer=setTimeout(flush,100);
    },
    dispose() { clearTimeout(timer); listeners.clear(); },
  };
}
export type ProgressStore = ReturnType<typeof createProgressStore>;
